<template>
  <div class="tiaoifyartic">
    <div class="artichea between">
      <div class="ticheatle">婚姻家庭法规</div>
      <div class="ifymo">更多 ></div>
    </div>
    <div class="articcont between">
      <div class="leftlist">
        <div
          class="lflitem flex_start"
          v-for="(item, index) in 10"
          :key="index"
          :class="{ lflitemactive: active == index }"
          @mouseover="active = index"
        >
          <div class="sortnum" :class="{ sortnum1: index < 3 }">
            {{ index + 1 }}
          </div>
          <div class="txt">
            <div class="tit ellipsis">中华人民共和国城市房地产管理法</div>
            <div class="des">
              {{
                `1994年7月5日第八届全国人民代表大会常务委员会第八次会议通过`
                  | toEllipsisFilter(32)
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="cent">
        <div class="ceto flex_start">
          <div class="cove">
            <img src="../../../assets/jpcol/artic1_sample.png" />
          </div>
          <div class="info">
            <div class="tit ellipsis">中华人民共和国婚姻法</div>
            <div class="dec">
              {{
                `1980年9月10日第五届全国人民代表大会第三次会议通过根据2001年4月28日第九届全国人民代表大会常务委员会第二十一次会议《`
                  | toEllipsisFilter(90)
              }}
            </div>
          </div>
        </div>
        <div class="cebtm">
          <div class="cebtmitem" v-for="item in 7" :key="item">
            最高人民法院关于适用 《中华人民共和国民法典》有关担保制度的...
          </div>
        </div>
      </div>
      <recomlayadv class="right" :xhnum="3" />
    </div>
  </div>
</template>

<script>
import recomlayadv from "views/tiaoli/components/recomlayadv";
export default {
  components: {
    recomlayadv,
  },
  data: () => ({
    active: 0,
  }),
};
</script>

<style lang="scss" scoped>
.tiaoifyartic {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  .artichea {
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
    .ticheatle {
      font-size: 30px;
      color: #333333;
    }
    .ifymo {
      cursor: pointer;
      margin-left: 40px;
      font-size: 14px;
      color: #999999;
    }
  }
  .articcont {
    margin-top: 30px;
    align-items: flex-start;
    .leftlist {
      width: 260px;
      .lflitem {
        cursor: pointer;
        align-items: flex-start;
        font-size: 14px;
        margin-bottom: 20px;
        .sortnum {
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background: #b2b2b2;
          border-radius: 50%;
          color: #ffffff;
          margin-right: 8px;
        }
        .sortnum1 {
          background: #ff8a22;
        }

        .txt {
          width: 85%;
          .tit {
            color: #333333;
          }
          .des {
            display: none;
            margin-top: 8px;
            font-size: 12px;
            color: #bbbbbb;
          }
        }
        &:hover {
          .txt .tit {
            color: #0465ea;
          }
        }
        &.lflitemactive {
          .txt .des {
            display: block;
          }
        }
      }
    }
    .cent {
      width: 620px;
      .ceto {
        align-items: flex-start;
        .cove {
          margin-right: 22px;
          img {
            width: 210px;
            height: 150px;
            border-radius: 5px;
          }
        }
        .info {
          padding-top: 8px;
          width: 60%;
          cursor: pointer;
          .tit {
            font-size: 20px;
            color: #333333;
          }
          .dec {
            line-height: 22px;
            margin-top: 10px;
            font-size: 14px;
            color: #999999;
          }
        }
      }
      .cebtm {
    margin-top: 34px;
        font-size: 18px;
        .cebtmitem {
          line-height: 18px;
          margin-top: 18px;
          padding-left: 25px;
          color: #333333;
          cursor: pointer;
          position: relative;

          &:hover {
            color: #0465ea;
          }
          &::before {
            content: "";
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            width: 8px;
            height: 8px;
            background: #dddddd;
            border-radius: 50%;
          }
        }
      }
    }
    .right {
      width: 270px;
      box-shadow: 0px 2px 15px 0px rgba(1, 1, 1, 0.1);
      height: 420px;
    }
  }
}
</style>